import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import weekday from "dayjs/plugin/weekday";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDateRelative = (d) => {
  const date = new Date(parseInt(d));
  const yesterday = Date.now() - 86400000;
  const last_week = Date.now() - 86400000 * 7;
  const last_year =
    Date.now() - (dayjs().valueOf() - dayjs().month(0).day(0).valueOf());

  if (d > yesterday) {
    return dayjs(date).fromNow();
  }
  if (d > last_week) {
    return dayjs(date).format("dddd");
  }
  if (d > last_year) {
    return dayjs(date).format("MMM DD");
  }
  return dayjs(date).format("MMM DD, YYYY");
};

export const formatDateTime = (d) => {
  if (d === 0) {
    return "";
  }
  return dayjs(d).format("MM/DD/YY h:mm A");
};

export const formatDateFromDateString = (d) => {
  if (d === 0) {
    return "";
  }
  return dayjs(d).format("MMM DD, YYYY");
};

export const formaTimeFromDateString = (d) => {
  if (d === 0) {
    return "";
  }
  return dayjs(d).format("h:mmA");
};

export const formatHHMMSSFromMs = (ms) => {
  var seconds = ms / 1000;
  var hours = parseInt(seconds / 3600);
  seconds = parseInt(seconds % 3600);
  var minutes = parseInt(seconds / 60);
  seconds = parseInt(seconds % 60);
  let hoursStr = ("00" + hours).slice(-2);
  let minutesStr = ("00" + minutes).slice(-2);
  let secondsStr = ("00" + seconds).slice(-2);

  return hoursStr + ":" + minutesStr + ":" + secondsStr;
};
